export const SETTINGS_TABS = ['profile', 'app-info', 'about'] as const;

export type SettingsTabId = (typeof SETTINGS_TABS)[number];

export const DEFAULT_SETTINGS_TAB: SettingsTabId = 'profile';

export function isSettingsTabId(
  value: string | undefined,
): value is SettingsTabId {
  return (
    value !== undefined && (SETTINGS_TABS as readonly string[]).includes(value)
  );
}

export function resolveSettingsTabPath(
  tabId: SettingsTabId = DEFAULT_SETTINGS_TAB,
): string {
  return `/settings/${tabId}`;
}
